import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectConfig } from '../../redux/slices/configSlice';
import {sendRichMessage}  from '../../utils/sendRichMessage';


const UsernameInput = () => {
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const reduxState = useSelector(state => state);
  const config = useSelector(selectConfig);
  const RmConfigs = config?.data?.[0]?.attributes.RichMediaConfigs;

  const validateUsername = (value) => {
    const usernameRegex = /^[a-zA-Z0-9]{3,15}$/;

    if (value.length < 3 || value.length > 15) { // RichmediaUsernameCharacterLimitErrorMessage
      return RmConfigs.RichmediaUsernameCharacterLimitErrorMessage; 
    }

    if (!usernameRegex.test(value)) { // RichmediaUsernameUnsupportedCharacterErrorMessage
      return RmConfigs.RichmediaUsernameUnsupportedCharacterErrorMessage;
    }

    return '';
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setUsername(value);
    setError(validateUsername(value));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationError = validateUsername(username);
    if (!validationError) {
      setIsSubmitted(true);
      console.log('Submitted username:', username);
      sendRichMessage(username, reduxState);
    } else {
      setError(validationError);
    }
  };

  return (
    <form onSubmit={handleSubmit}
    style={{
        display: 'flex',
        flexFlow: 'column',
        width: 'auto',
        textAlign: 'left',
        background:'#e5e5ea',
        padding: '12px',
        borderRadius:'12px',
        margin:'12px 12px 0 30px' 
      }}
    >
      <input
        type="text"
        id="username"
        value={username}
        onChange={handleChange}
        placeholder={RmConfigs.RichmediaUsernamePlaceholder}
        disabled={isSubmitted}
        style={{ width: '150px', padding: '6px' }}
      />
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <button
        type="submit"
        disabled={!!error || username === '' || isSubmitted}
        className='dafabet'
        style={{
          borderColor: "transparent",
          borderRadius: "14px",
          padding: "0.4rem 2rem",
          margin: "0.5rem 0",
          backgroundColor: isSubmitted || !!error || username === '' ? "lightgray" : "#af0000",
          color:  isSubmitted || !!error || username === '' ? "darkgray" : "#fff",
          textTransform: "capitalize",
          cursor:  isSubmitted || !!error || username === '' ? "not-allowed" : "pointer",
        }}
      >
      提交
      </button>
    </form>
  );
};

export default UsernameInput;
